module.exports = __webpack_public_path__ + "e4adc9121e9e8f5bddc07c4dcbfc37fb.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/GT-Sectra-Display-Regular-Italic.ttf
// module id = 44
// module chunks = 0